<div class="countdown" *ngIf="!hidden">
  <div class="days">
    <ng-container *ngFor="let day of days">
      <span>{{day}}</span>
    </ng-container>
    <div class="label">Tage</div>
  </div>
  <div class="hours">
    <ng-container *ngFor="let hour of hours">
      <span>{{hour}}</span>
    </ng-container>
    <div  class="label">Stunden</div>
  </div>
  <div class="minutes">
    <ng-container *ngFor="let minute of minutes">
      <span>{{minute}}</span>
    </ng-container>
    <div class="label">Minuten</div>
  </div>
</div>
